import type { MessageKey } from 'types/LocaleMessageKey';

export interface BenefitsItem {
  id: string;
  text: MessageKey;
}

interface BenefitsListType {
  sanFrancisco: BenefitsItem[];
  helsinkiAndOulu: BenefitsItem[];
}

export const benefitsList: BenefitsListType = {
  sanFrancisco: [
    {
      id: 'sf-0',
      text: 'competitive_salary_and_equity',
    },
    {
      id: 'sf-1',
      text: 'health_dental_and_vision',
    },
    {
      id: 'sf-2',
      text: 'an_oura_ring_of_your_own',
    },
    {
      id: 'sf-3',
      text: 'fertility_benefits',
    },
    {
      id: 'sf-4',
      text: 'flexible_working_hours_and_worklife_balance',
    },
    {
      id: 'sf-5',
      text: '20_days_of_pto',
    },
    {
      id: 'sf-6',
      text: 'parental_leave',
    },
    {
      id: 'sf-9',
      text: 'amazing_culture',
    },
  ],
  helsinkiAndOulu: [
    {
      id: 'hi-0',
      text: 'competitive_salary',
    },
    {
      id: 'hi-1',
      text: 'lunch_benefit',
    },
    {
      id: 'hi-2',
      text: 'wellness_benefit',
    },
    {
      id: 'hi-3',
      text: 'flexible_hours',
    },
    {
      id: 'hi-4',
      text: 'smart_team',
    },
    {
      id: 'hi-5',
      text: 'an_oura_ring',
    },
    {
      id: 'hi-6',
      text: 'learning-and-dev-budget',
    },
    {
      id: 'hi-7',
      text: 'wellness_time',
    },
    {
      id: 'hi-8',
      text: 'easy_to_reach_offices_finland',
    },
  ],
};
